export default __webpack_public_path__ + "static/ensino-fudamental-2-f2adb9c7c876546ac224d5a032311c7d.png";